export default function GetMemberName({ members, memId }) {
  const searchMem = members.find((member) => member.id == memId);
  return searchMem
    ? searchMem.first_name + " " + searchMem.last_name
    : "חבר לא מוגדר";
}
